import { gql } from '@apollo/client';

export const GET_STORE_BY_USER = gql`
  query GetStoreByUser($userId: ID!) {
    getStoreByUser(userId: $userId) {
      ... on GetStoreByUserSuccess {
        code
        store {
          id
          encStoreId
          name
          websiteUrl
          monthlyOrders
          timezone
          email
          telephone
          imageUrl
          cnpj
          address {
            street
            number
            complement
            district
            city
            state
            zipCode
            reference
          }
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
